export default __webpack_public_path__ + "static/media/user.21c68524.png";